export const getPriceSliderRange = (range: [number, number]): [number, number] => {
  const min = range[0] === 0 ? 100 : range[0];
  const max = range[1];

  return [min, max];
};
